import type { ICartBasket, TOrderTypes } from '@/shared/types/cart';

import { createSelector } from '@reduxjs/toolkit';

export const getOrderTypes = ({ main }: CartRootState): TOrderTypes => main.orderTypes;

export const getBaskets = ({ main }: CartRootState): ICartBasket[] | undefined =>
  main.model?.Baskets;
export const getCountBaskets = createSelector(getBaskets, (baskets) => {
  return baskets?.length || 0;
});
export const getIsCartEmpty = createSelector(getCountBaskets, (count) => {
  return count === 0;
});
export const getIsPaypalOnList = createSelector(getBaskets, (baskets) => {
  return baskets?.some((basket) => basket?.PayPalMessage);
});
